// BarcodeScanner.js
import React, { useEffect, useRef } from 'react';
import Quagga from 'quagga';

const BarcodeScanner = () => {
    const scannerRef = useRef();

    // Function to handle detected barcode
    const handleDetected = (result) => {
        const barcode = result.codeResult.code;
        console.log("Detected Barcode:", barcode);
        // Here you can handle the barcode data (e.g., update local state, make API call, etc.)
    };

    useEffect(() => {
        Quagga.init({
            inputStream: {
                type: "LiveStream",
                target: scannerRef.current, // Pass the ref to the Quagga library
                constraints: {
                    facingMode: "environment"
                },
            },
            decoder: {
                readers: ["code_128_reader", "ean_reader", "ean_8_reader", "code_39_reader", "code_39_vin_reader", "codabar_reader", "upc_reader", "upc_e_reader", "i2of5_reader"],
            },
        }, (err) => {
            if (err) {
                console.error(err);
                return;
            }
            Quagga.start();
        });

        Quagga.onDetected(handleDetected);

        return () => {
            Quagga.offDetected(handleDetected);
            Quagga.stop();
        };
    }, []);

    return <div ref={scannerRef} style={{ position: 'relative', width: '100%', height: '100%' }} />;
};

export default BarcodeScanner;
